{
  document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector("body header-component.header");
    let lastScrollTop = 0;

    function toggleHeaderClass() {
      if (!header) return;

      const scrollTop =
        window.pageYOffset || document.documentElement.scrollTop;

      if (scrollTop <= 50) {
        header.classList.remove("headertop");
        header.classList.remove("headersticky");
      } else {
        header.classList.add("headertop");

        if (scrollTop < lastScrollTop) {
          // scroll up
          header.classList.add("headersticky");
          header.classList.remove("headertop");
        } else {
          // scroll down
          header.classList.remove("headersticky");
        }
      }

      lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }

    window.addEventListener("scroll", toggleHeaderClass);
    window.addEventListener("load", toggleHeaderClass);
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    document.addEventListener("DOMContentLoaded", function () {
      const modal = document.querySelector(".modal__Cus");
      const modalContainer = document.querySelector(".modal__Container");

      if (!modal || !modalContainer) return;

      // Initially hidden
      modal.style.display = "none";

      // 👉 Auto open after 5 seconds
      setTimeout(() => {
        modal.classList.add("active");
        modal.style.display = "flex";
        document.body.classList.add("overflow-hidden"); // optional scroll lock
      }, 5000);

      // 👉 Close on outside click
      modal.addEventListener("click", function (e) {
        if (!modalContainer.contains(e.target)) {
          closeModal();
        }
      });

      // 👉 ESC key close (bonus UX)
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          closeModal();
        }
      });

      function closeModal() {
        modal.classList.remove("active");
        modal.style.display = "none";
        document.body.classList.remove("overflow-hidden");
      }
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const videoBoxes = document.querySelectorAll(".mainVideoBox");
    videoBoxes.forEach((box) => {
      const video = box.querySelector("video");
      const togglePlay = () => {
        if (video.paused) {
          video.controls = true; // Show controls
          video.play();
          box.classList.add("is-playing");
        } else {
          video.pause();
          video.controls = false; // Hide controls
          box.classList.remove("is-playing");
        }
      };
      box.addEventListener("click", togglePlay);
      video.addEventListener("ended", () => {
        box.classList.remove("is-playing");
        video.controls = false; // Hide controls when ended
        video.currentTime = 0;
      });
    });
  });
}
{
  document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("#header-component");
    if (!header) return;
    let ticking = false;
    function updateMenuStyle() {
      const target = window.innerWidth <= 1200 ? "drawer" : "menu";
      const current = header.getAttribute("data-menu-style");
      if (current !== target) {
        header.setAttribute("data-menu-style", target);
      }
      ticking = false;
    }
    updateMenuStyle();
    window.addEventListener("resize", updateMenuStyle, { passive: true });
    const observer = new MutationObserver(() => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateMenuStyle);
      }
    });
    observer.observe(header, {
      attributes: true,
      attributeFilter: ["data-menu-style"],
    });
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    Fancybox.bind("[data-fancybox]", {});
  });
}

{
  document.addEventListener("DOMContentLoaded", function () {
    const allAccordions = document.querySelectorAll(".accordion_cus");
    allAccordions.forEach((accordion) => {
      const items = accordion.querySelectorAll(".acco_cus_item");
      if (items.length > 0) {
        items[0].classList.add("open");
      }
      items.forEach((item) => {
        const header = item.querySelector(".acc-header");
        header.addEventListener("click", () => {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains("open")) {
              otherItem.classList.remove("open");
            }
          });
          item.classList.toggle("open");
        });
      });
    });
  });
}